/**
 * Created by CoolGuy on 2017/8/24.
 */
import React,{Component} from "react";
import {connect} from "react-redux";
import {Button,Input, Select, Icon} from "antd";
import funcutil from '../../util/func';
import './Search.scss';
import ajaxUtil from '../../util/ajax';
import {isWeb} from "../../util";
const Search = Input.Search;
const {DOMAIN_CURRENT, ajaxv2} = ajaxUtil;

//规则参考
/*{
 "id":1,       // id=1 --- rule传""
 "id":[1,2,4]     // id=1或者 id=2或者id=4---暂不支持
 "id[>]":1
 "id[<=]":1,
 "id[~]":"100"  // 模糊查询,
 }*/


//支持的格式
//参考defaultKeys，如果只有name字段需要指定(即默认为模糊匹配)，可以用：
//其中key值(id/name)表示的是要查询的key
//let a ={
//    id:"订单号",
//    name:"订单名称"
//};


//默认情况是搜索订单号和活动名称，理论上除了订单都需要修改~
const defaultKeys = {
    id: {
        name: "订单号",
        rule: "[~]", // 模糊查询，可以为空如果不传rule采用[~]
    },
    name: {
        name: "活动名称",
        rule: "[~]"
    },
    tag:{
      name:"标签或相册名称",
      rule:"[~]"
    },
    // price: {
    //     name: "金额",
    //     rule: "[~]"
    // }
};

class TheSearch extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mode:"keyword",
      value:"",
      options:[],
      categorys:[]
    };

    this.debounceSearch = funcutil.debounce(this.handleSearch, 300, false);
  }

  componentDidMount() {
    if(!!this.props.tagMode) {
      ajaxv2({
        url:DOMAIN_CURRENT + '/api/v2/tags/category/list'
      }).then(res=>{
        let map = {};
        (res || []).forEach(it=>{
          map[it.id] = it.name;
        });
        this.setState({
          categorys:map
        });
      })
    }
  }

    getKeys = ()=> {
        let keys = this.props.keys || defaultKeys;
        let names = [], ids = {};
        for(let x in keys){
            let one = keys[x];
            if(typeof one === 'string'){
                names.push(one);
                ids[`${x}[~]`] = "";
            }else{
                let rule = one.rule !== undefined ? one.rule : "[~]";
                names.push(one.name);
                ids[`${x}${rule}`]='';
            }

        }
        return {
            names,ids
        }
    }

    handleSearch = (e)=>{
      console.log('search', e);
      if(e) {
        ajaxv2({
          url:`${DOMAIN_CURRENT}/api/v2/tags/detail/collection/search`,
          data:{
            name:e
          }
        }).then(res=>{
          let array = [];
          let {categorys} = this.state;

          if(res && Object.keys(res || []).length) {
            Object.keys(res || {}).forEach(key=>{
              array.push({
                key:'cate'+key,
                name:categorys[key],
                disabled:true
              });

              let sub = res[key];
              if(sub && sub.length) {
                sub.forEach(tag=>{
                  array.push({
                    key:tag.id,
                    name:tag.name,
                    disabled:false
                  });
                });
              }
            })
          }

          console.log(array);
          this.setState({
            options:array
          });
        });
      }
    }

    handleChange = (e)=>{
      this.setState({
        value:e
      });
    }


    //搜索一定是从第一页搜索起的
    search = (value)=> {
      let {mode, options} = this.state;
      let {style, tagMode}= this.props;

      let {ids} = this.getKeys();
      for(let x in ids){
          ids[x]=value
      }
      let key = value ? JSON.stringify({
          OR: ids
      }):undefined;
      this.props.getList && this.props.getList({
          current: 1,
          search:value,
          tag:tagMode ? (mode == 'tagname' ? 1 : 0) : 0
      });
    }

    renderModeSelect = ()=>{
      return <Select value={this.state.mode} style={{marginRight:10}} onChange={(e)=>{
        this.setState({
          mode:e,
          value:e == 'tagname' ? [] : ''
        });
      }}>
        <Select.Option value="keyword">关键字</Select.Option>
        <Select.Option value="tagname">标签</Select.Option>
      </Select>
    }

    renderTagMode = ()=>{
      const {names} = this.getKeys();
      let {mode, options} = this.state;
      let {style, tagMode}= this.props;

      return <div className="common-search">
        {isWeb() && this.renderModeSelect()}
        {mode == 'keyword' ? (
          <Search style={style?style:{width:300}}
            placeholder={""+names.join("或")}
                  allowClear
            onSearch={this.search}
          />
        ) : null}
        {mode == 'tagname' ? (
          <React.Fragment>
            <Select
              mode="multiple"
              labelInValue
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              style={style?style:{width:300}}
              value={this.state.value}
              placeholder={'请输入标签名称，根据搜索结果选择标签'}
              onSearch={this.debounceSearch}
              onChange={this.handleChange}
              notFoundContent={null}
            >
              {options.map(it=>(
                <Select.Option key={it.key} disabled={it.disabled}>{it.name}</Select.Option>
              ))}
            </Select>
            <Icon type="search" className="button-search" onClick={()=>this.search((this.state.value || []).map(it=>it.key).join(' '))} />
          </React.Fragment>
        ) : null}
      </div>;
    }

    renderNormalMode = ()=>{
      const {names} = this.getKeys();
      let {mode} = this.state;
      let {style, tagMode}= this.props;

      return <Search style={style?style:{width:200}}
        placeholder={this.props.placeholder ? this.props.placeholder : (""+names.join("或"))}
        onSearch={this.search}
      />;
    }

    render() {
        const {names} = this.getKeys();
        let {mode} = this.state;
        let {style, tagMode}= this.props;

        return <>
          {tagMode ? this.renderTagMode() : this.renderNormalMode()}
        </>;

        // return (
        //     // <Search style={style?style:{width:200}}
        //     //         placeholder={""+names.join("或")}
        //     //         onSearch={this.search}
        //     // />
        //     tagMode ? (
        //       <Input style={style?style:{width:400}} value={this.state.value} onChange={(e)=>this.setState({value:e.target.value})}
        //         placeholder={mode == 'keyword' ? "输入订单号、活动名称等" : "输入完整的标签名称，多个标签，以空格分隔"}
        //         addonBefore={this.renderModeSelect()} addonAfter={<Icon type="search" onClick={()=>this.search(this.state.value)} />} />
        //     ) : <Search style={style?style:{width:200}}
        //       placeholder={""+names.join("或")}
        //       onSearch={this.search}
        //     />
        // );
    }
}
export default connect()(TheSearch);



// WEBPACK FOOTER //
// ./src/components/Common/Search.js